import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_SSR_STATUS
    SET_DETAILS
    FETCH_LANDING_PAGE_DATA_SUCCESS
    SET_LOADNG_STATE
`,
    {
        prefix: "sflandingpagedata/"
    }
);
